import * as React from "react";

function SvgCoffee(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.89 17.92"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M0 14.66h23.07a3.13 3.13 0 01-1 2.31 3.22 3.22 0 01-2.33 1H3.3a3.22 3.22 0 01-2.35-.98A3.14 3.14 0 010 14.66zM22.45 1.44a4.65 4.65 0 011.5 3.45 4.68 4.68 0 01-1.5 3.46 4.82 4.82 0 01-3.5 1.43h-.82v.41a2.71 2.71 0 01-.85 2 2.79 2.79 0 01-2 .84h-9.1a2.79 2.79 0 01-2-.84 2.71 2.71 0 01-.85-2V.82a.78.78 0 01.21-.57.83.83 0 01.58-.26h14.83a4.79 4.79 0 013.5 1.45zm-1.74 5.18a2.33 2.33 0 00.72-1.73 2.35 2.35 0 00-.72-1.73 2.45 2.45 0 00-1.76-.71h-.82v4.89h.82a2.42 2.42 0 001.76-.72z" />
    </svg>
  );
}

const MemoSvgCoffee = React.memo(SvgCoffee);
export default MemoSvgCoffee;
